import React from 'react';
import { Box, Card, Stack } from '@mui/material';

import { CandidateDetailsAction } from '@constants';
import { CandidatesWithPosition } from '@types';
import { CandidateListAction } from './CandidateListAction';
import { CandidateNameCell } from './CandidateNameCell';
import { ResumeLink } from './CandidateMaterials';
import { listCardSx } from 'theme/surfaces';

interface ICandidateCardProps {
  candidate: CandidatesWithPosition;
  onAction: (id: string, action: CandidateDetailsAction) => void;
  positionName?: string;
  onClick: () => void;
}

export const CandidateCard: React.FC<ICandidateCardProps> = ({
  candidate,
  positionName,
  onClick,
  onAction,
}) => (
  <Card
    variant="outlined"
    onClick={onClick}
    sx={{ ...listCardSx, pt: 1, pb: 2, cursor: 'pointer' }}
  >
    <Stack gap={1}>
      <CandidateNameCell
        candidate={candidate}
        positionName={positionName}
        withRegion={false}
      />

      <Box
        display="flex"
        alignItems="center"
        gap={1}
        rowGap={1.5}
        flexWrap="wrap"
      >
        <CandidateListAction candidate={candidate} onAction={onAction} inCard />
        <Box ml="auto">
          <ResumeLink candidate={candidate} label="Resume" />
        </Box>
      </Box>
    </Stack>
  </Card>
);
